const PARTNER_APPS = [
  { name: "Nexxaris", url: "https://www.nexxaris.com" },
  { name: "Rating Online", url: "https://www.ratingonline.store" },
  { name: "Business Plan", url: "https://businessplan.ratingonline.store" },
];

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export function AppFooter({ variant = "light", className = "" }) {
  const isDark = variant === "dark";
  const labelCls = isDark ? "text-slate-500" : "text-zinc-400";
  const linkCls = isDark ? "text-slate-300 hover:text-white" : "text-zinc-500 hover:text-[#E07B2E]";
  const borderCls = isDark ? "border-white/10" : "border-zinc-200";

  return (
    <footer data-testid="app-partner-footer" className={`border-t ${borderCls} ${className}`}>
      <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1 text-xs">
        <span className={`font-mono uppercase tracking-wider ${labelCls}`}>App collegate</span>
        {PARTNER_APPS.map((app, i) => (
          <span key={app.name} className="flex items-center gap-2.5">
            {i > 0 && <span className={labelCls} aria-hidden="true">·</span>}
            <a
              href={app.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`partner-link-${slug(app.name)}`}
              className={`font-medium transition-colors duration-150 ${linkCls}`}
            >
              {app.name}
            </a>
          </span>
        ))}
      </div>
    </footer>
  );
}
